export default __webpack_public_path__ + "static/media/electric.5b9316bb.svg";